import React, { useState, useEffect } from 'react';
import Api from './Config';
import _ from 'lodash';
import moment from 'moment';
import { Line } from 'react-chartjs-2';

const AverageResponseChart = ({ category, monthlyDates, isLast, journeyStartDate }) => {
  const [systolicAverage, setSystolicAverage] = useState(null);
  const [diastolicAverage, setDiastolicAverage] = useState(null);
  const [graphLabels, setGraphLabels] = useState([]);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  useEffect(() => {
    const getAverage = async () => {
      let sysAvg = [];
      let diasAvg = [];
      let labels = [];

      for (const month of monthlyDates) {
        const startDate = month.startDate;
        const endDate = month.endDate;
        const currentMonth = parseInt(moment(startDate).format('M'));
        labels.push(monthNames[currentMonth - 1] + ' ' + moment(startDate).format('YYYY'));

        let data;
        if (isLast) {
          data = await Api.getAverageLastResponses(category, startDate, endDate, false);
        } else {
          data = await Api.getAverageAllResponses(category, startDate, endDate, false, journeyStartDate);
        }

        if (data['avgOverall']) {
          sysAvg.push(data['avgOverall']['average_bio']['systolic'].toFixed(2));
          diasAvg.push(data['avgOverall']['average_bio']['diastolic'].toFixed(2));
        } else {
          sysAvg.push(0);
          diasAvg.push(0);
        }
      }

      setSystolicAverage(sysAvg);
      setDiastolicAverage(diasAvg);
      setGraphLabels(labels);
    };

    getAverage();
  }, [monthlyDates]);

  return (
    <Line
      height={100}
      data={{
        labels: graphLabels,
        datasets: [
          {
            label: 'Average Diastolic',
            fill: true,
            backgroundColor: 'rgba(233,0,0,1)',
            borderColor: 'rgba(233,0,0,1)',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointRadius: 5,
            pointHitRadius: 10,
            lineTension: 0,
            data: diastolicAverage,
          },
          {
            label: 'Average Systolic',
            fill: true,
            backgroundColor: 'rgba(0,49,229,.5)',
            borderColor: 'rgba(0,49,229,.5)',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointRadius: 5,
            pointHitRadius: 10,
            lineTension: 0,
            data: systolicAverage,
          },
        ],
      }}
      options={{
        legend: {
          display: true,
          position: 'bottom',
          reverse: true,
          onClick: () => {},
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: _.max(_.map(systolicAverage, (a) => parseInt(a))) + 20,
                suggestedMin: 0,
              },
              scaleLabel: {
                display: true,
                labelString: 'Blood Pressure (mmhg)',
              },
              type: 'linear',
              display: true,
              position: 'left',
              id: 'y-axis-1',
            },
          ],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }}
    />
  );
};

export default AverageResponseChart;
